import { SET_MODAL } from 'store/types/modalActionTypes';

import helper from 'store/actions/actionHelper';

export const setModal = (data: string | CommonModal | null) =>
  helper.getAction(SET_MODAL, data);
